// VIP clients list - shared across components
export const VIP_CLIENTS = [
  'BEMA S.A.',
  'Loken SpA',
  'RESTAURANTES BOLOGNA LTDA',
  'GMW FOOD S.P.A.',
  'SOC. RISTORANTE LE DUE TORRI LTDA.',
  'ICAL LTDA',
  'COMER Y BEBER S.A.',
  'PASTAMORE SPA',
  'GASTRONOMIA ITALIANA SPA',
  'BRASSERIE DEL PARQUE FORESTAL SPA',
  'SIETE TENEDORES SPA',
  'LA FABBRICA SPA',
  'COMO EN ITALIA SPA',
  'FAVALI LIMITADA',
  'LA DIVINA COMIDA LIMITADA',
  'GRUPO MINGA SPA',
  'DK SANTIAGO SPA',
  'COMER Y BEBER S.A.',
  'GASTRONOMIA ALC ITALIANA SPA',
  'INVERSIONES PREGO SPA',
  'CHARCUTERIA LO CURRO SPA',
  'GIOIA SPA',
  'DAVVERO SPA',
  'PIZZERÍA BJH SPA',
  'COMERCIAL Z GOURMET MARKET SPA',
  'LA COCINA MAGICA SPA',
  'ROTISERIA CRISTIAN PEÑA SUAREZ E.I.R.L',
  'BEER GARDEN BELLAVISTA SPA',
  'PIZZERÍA BJH SPA',
  'Bema S.A.',
  'PASTAMORE SPA',
  'LA BOTTEGA GANDOLINI SPA',
  'DAVVERO SPA',
  'AGU SPA',
  'COMER Y BEBER S.A.',
  'COMER Y BEBER S.A.',
  'COMER Y BEBER S A',
  'LA FABBRICA SPA',
  'GASTRONOMICA HUISHUE S.A.',
  'LA COCINA MAGICA SPA',
  'GASTRONOMICA HUISHUE S.A.',
  'DICA SPA',
  'EL GASTRONOMICO SPA',
  'RESTAURANTES BOLOGNA LTDA',
  'BRASSERIE DEL PARQUE FORESTAL SPA',
  'BEER GARDEN BELLAVISTA SPA',
  'GASTRONOMICA HUISHUE S.A.',
  'SOCIEDAD GASTRONOMICA DE INVERSIONES ALLERIA SPA',
  'COMER Y BEBER S A',
  'SIETE TENEDORES SPA',
  'LA FABBRICA SPA',
  'INVERSIONES GAA SPA',
  'SOC. RISTORANTE LE DUE TORRI LTDA.',
  'PANIFICADORA PAN BOL LTDA',
  'LA BOTTEGA GANDOLINI SPA',
  'COMER Y BEBER S.A.',
  'SOC. RISTORANTE LE DUE TORRI LTDA.',
  'GMW FOOD S.P.A.',
  'COMO EN ITALIA SPA',
  'SIETE TENEDORES SPA',
  'SIETE TENEDORES SPA',
  'BEER GARDEN BELLAVISTA SPA',
  'COMER Y BEBER S.A.',
  'GASTRONOMIA ITALIANA SPA',
  'GRUPO MINGA SPA',
  'GIOIA SPA',
  'GIOIA SPA',
  'BEER GARDEN BELLAVISTA SPA',
  'GRAN GOURMET ITALIA LTDA (FRIO)',
  'GOURMITALIA LTDA - VITACURA',
  'GRAN GOURMET ITALIA LTDA (MALL VIVO LOS TRAPENSES)',
  'GRAN GOURMET ITALIA LTDA (VITACURA)',

];
